<template>
  <div :class="componentClasses">
    <select
      :value="selectValue"
      @change="handleChange"
    >
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
    <Icon />
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
import Icon from '../../graphic/icon/Icon.vue';

const props = defineProps({
  value: String,
  modelValue: String,
  options: {
    type: Array,
    required: true,
  },
  size: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['input', 'update:modelValue']);
const selectValue = computed(() => {
  // Prefer modelValue if defined (even if it's an empty string)
  return props.modelValue !== undefined ? props.modelValue : props.value
})

const handleChange = event => {
  const newValue = event.target.value;

  // Emit the standard v-model event
  emit('input', newValue); // Vue 2
  emit('update:modelValue', newValue); // Vue 3
  emit('change', newValue);
};

const componentClasses = computed(() => [
  'stk-select',
  props.size && `stk-size-${props.size}`,
]);
</script>
